import {I18nextProvider} from "react-i18next";
import i18n from "i18next";
import ReactDOM from "react-dom";

export function renderPartialWithI18n(component: JSX.Element, selector: string) {
    const node = document.querySelector(selector);
    if (node) {
        ReactDOM.render(
            <I18nextProvider i18n={i18n}>{component}</I18nextProvider>, node
        );
    }
}